module.exports = __webpack_public_path__ + "img/gywm_bg.9b2988b1.jpg";